var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(-1133 -283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(1147.001 300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plant",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M15.347,25.3c-3.335-3.333-9.861-3.72-14.48-3.72A.867.867,0,0,0,0,22.446c0,4.619.385,11.145,3.72,14.48a8.072,8.072,0,0,0,5.7,2.037,8.645,8.645,0,0,0,5.923-2.038C17.831,34.44,18.287,28.237,15.347,25.3ZM14.122,35.7c-1.855,1.853-7,2.17-9.175,0C2.255,33.009,1.789,27.54,1.739,23.317c4.222.05,9.691.517,12.383,3.208C16.292,28.7,15.974,33.848,14.122,35.7Z",
    transform: "translate(0 -21.579)",
    fill: "#595959"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(21.883 3.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M272.38,63.776c-4.619,0-11.145.385-14.48,3.72-2.94,2.938-2.484,9.142,0,11.626a8.648,8.648,0,0,0,5.921,2.037,8.081,8.081,0,0,0,5.706-2.035c3.333-3.335,3.72-9.861,3.72-14.48A.867.867,0,0,0,272.38,63.776ZM268.3,77.9c-2.17,2.17-7.321,1.853-9.174,0s-2.17-7,0-9.175c2.692-2.692,8.16-3.158,12.383-3.208C271.456,69.737,270.99,75.206,268.3,77.9Z",
    transform: "translate(-255.862 -63.776)",
    fill: "#595959"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(7.476 6.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M109.443,110.924a.936.936,0,0,0-1.222-.383c-6.647,3.125-9.913,8.575-11.4,14.177-1.836-11.912-7.145-15.543-9.4-17.084a5.439,5.439,0,0,1-.621-.452.867.867,0,1,0-1.226,1.226,6.972,6.972,0,0,0,.868.657c2.538,1.735,9.279,6.348,9.279,24.73a.867.867,0,0,0,1.733,0c0-7.427,2-17.219,11.5-21.684,0,0,.14-.068.14-.068A.8.8,0,0,0,109.443,110.924Z",
    transform: "translate(-85.328 -106.928)",
    fill: "#595959"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.031de884b54e9aa8063a3e06fd4ebd45.svg";
export { ForwardRef as ReactComponent };